import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { SetA2HSAcknowledged } from "@platform-app/app/shared/common/store/a2hs/a2hs.actions";

export interface A2HSStateModel {
  a2hsAcknowledged: boolean;
}

const DEFAULT_A2HS_STATE: A2HSStateModel = {
  a2hsAcknowledged: false,
};

@State<A2HSStateModel>({
  name: "A2HSState",
  defaults: DEFAULT_A2HS_STATE,
})
@Injectable()
export class A2HSState {
  @Selector()
  static acknowledged(state: A2HSStateModel) {
    return state.a2hsAcknowledged;
  }

  @Action(SetA2HSAcknowledged)
  setA2HSAcknowledged(ctx: StateContext<A2HSStateModel>) {
    ctx.patchState({
      a2hsAcknowledged: true,
    });
  }
}
